import React from 'react'
import { RichText, type ComponentProps, type ExtendedRichTextData, type PartData } from '@enonic/react-components'
import FaqPrototype from '/react4xp/components/prototype/Faq'
import type { FaqItem } from '/react4xp/components/prototype/Faq/types'

type FaqEntry = {
	title?: string
	text?: ExtendedRichTextData
	open?: boolean
}

type FaqPartData = {
	heading?: string
	entries?: FaqEntry[]
}

export const Faq = ({ component, meta, data, common }: ComponentProps<PartData>) => {
	const { heading, entries = [] } = (data || {}) as FaqPartData

	if (entries.length === 0) return <></>

	// The prototype's FaqItem.answer is typed `string`, but this field's HtmlArea
	// includes Macro — only @enonic/react-components's RichText hydrates macro
	// placeholders, so a ReactNode is passed here instead of a raw HTML string.
	const items = entries.map((entry) => ({
		question: entry.title,
		answer: entry.text && <RichText tag="div" data={entry.text} component={component} meta={meta} common={common} />,
		open: entry.open,
	}))

	return <FaqPrototype heading={heading} items={items as unknown as FaqItem[]} />
}
